export default __webpack_public_path__ + "static/media/Group9227.3b20d2c2.svg";